var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack226({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5,12.52V3.93H7.76a10.66,10.66,0,0,1,2.07.13,2.25,2.25,0,0,1,1.23.84,2.67,2.67,0,0,1,.5,1.67,2.78,2.78,0,0,1-.29,1.33,2.26,2.26,0,0,1-.73.85,2.43,2.43,0,0,1-.9.41,10.09,10.09,0,0,1-1.8.12H6.71v3.24ZM6.71,5.39V7.82h1A4.49,4.49,0,0,0,9,7.69a1.16,1.16,0,0,0,.55-.42,1.19,1.19,0,0,0,.19-.67,1.16,1.16,0,0,0-.27-.78,1.24,1.24,0,0,0-.7-.38,8.63,8.63,0,0,0-1.25-.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack226);
export default __webpack_public_path__ + "static/media/Symbolpack_2_26.922e6e95371418213dde6a56fcd86b90.svg";
export { ForwardRef as ReactComponent };